module.exports = __webpack_public_path__ + "img/submitSelfAssessment.8224343c.svg";